import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import ModalDialog from '../../../common/modal-dialog/modal-dialog.component';
import { ModalTextBody } from '../../../common/modal-dialog/modal-dialog.styles';
import { HeaderSecondary } from '../../../common/typography/typography.styles';
import { useStore } from '../../../stores/store';
import { DeliveryRoute } from '../../../models/shipmentCountryInfo';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  body?: string;
  showNotifyButton?: boolean;
}

const ModalUnsupportedShippingDirection = ({
  isOpen = false,
  onClose,
  title,
  body,
  showNotifyButton = true,
}: Props) => {
  const {
    parcelCreationStore: {
      isRouteExpectationLoading,
      registerRouteExpectation,
      countryDeparture,
      countryDestination,
    },
  } = useStore();
  const { t } = useTranslation();

  const handleNotifyMe = async () => {
    if (!countryDeparture || !countryDestination) {
      onClose();
      return;
    }

    const expectRouteRequest: DeliveryRoute = {
      departure_country: countryDeparture.code,
      departure_zip: countryDeparture.zipCode,
      destination_country: countryDestination.code,
      destination_zip: countryDestination.zipCode,
    };

    await registerRouteExpectation(expectRouteRequest);
    onClose();
  };

  return (
    <ModalDialog
      approveBtnContent={
        showNotifyButton
          ? t('unsupported_direction_modal_notify_me')
          : undefined
      }
      cancelBtnContent={t('cancel')}
      isOpen={isOpen}
      isLoading={isRouteExpectationLoading}
      onApprove={handleNotifyMe}
      onClose={onClose}>
      <HeaderSecondary>{title}</HeaderSecondary>
      <ModalTextBody>{body}</ModalTextBody>
    </ModalDialog>
  );
};

export default observer(ModalUnsupportedShippingDirection);
